import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import CourseList from './CourseList';
import CourseDetail from './CourseDetail';
import Navbar from './components/Navbar';
import About from './components/About';
import Contact from './components/Contact';
import Courses from './components/Courses';
import Register from './components/Register';
import Login from './components/Login';
import Profile from './components/Profile'; // Ensure the Profile component can handle dynamic userId
import ProfileSetup from './components/ProfileSetup';
import ProtectedRoute from './components/ProtectedRoute';
import Feed from './components/MessageBoard/Feed';
import PostDetail from "./components/MessageBoard/PostDetail";
import MessageBoard from "./components/MessageBoard/MessageBoard";
import MobileNavbar from './components/MobileNavbar';
import Logout from "./components/Logout";
import Forums from "./components/MessageBoard/Forums"
import Forum from "./components/MessageBoard/Forum"
import StateForum_Unique from "./components/MessageBoard/StateForum_Unique";
import ForumPostDetail from "./components/MessageBoard/ForumPostDetail";
import MyIQ from "./components/MyIQ"
import ClubRequests from "./components/ClubRequests";
import Chat from "./components/Chat";
import PublicProfile from "./components/PublicProfile"
import LandingPage from "./components/LandingPage";
import ContributionsPage from "./components/ContributionsPage";

import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PrivacyChoices from "./components/PrivacyChoices";
import PublicFinancials from "./PublicFinancials";
import Success from "./components/Success";
import Cancel from "./components/Cancel";
import Checkout from "./components/Checkout";
import ForgotPassword from './components/ForgotPassword';
import ForgotUsername from './components/ForgotUsername';
import ResetPassword from './components/ResetPassword';
import ScrollToTop from './components/ScrollRestoration';
import './tailwind-fallback.css';
import ReferralDashboard from "./components/ReferralDashboard";
import ClubLogin from "./components/club_interface/ClubLogin";
import ClubDashboard from "./components/club_interface/ClubDashboard";
import PartnersDiscountsPage from "./components/PartnersDiscountsPage"
import ModernTable from "./components/ModernTable"
import MemberPortalRouter from "./components/MemberPortal/MemberPortalRouter";
import Unsubscribe from "./components/Unsubscribe";
import UnsubscribeSuccess from "./components/UnsubscribeSuccess";
import ClubRegister from "./components/club_interface/ClubRegister";
import AppStoreBanner from "./components/AppStoreBanner";

// Wrapper component to conditionally render navbars based on route
function AppContent() {
  const location = useLocation();
  const token = localStorage.getItem('access_token');

  // Hide navbars on ClubDashboard routes (they have their own sidebar navigation)
  const isClubDashboard = location.pathname.startsWith('/myclub/dashboard');

  return (
    <>
      <ScrollToTop />
      <AppStoreBanner />
      {!isClubDashboard && <Navbar />}
      <Routes>
        {/* Default route - Redirect to CourseList if logged in, otherwise to LandingPage */}
        <Route
            path="/"
            element={token ? <Navigate to="/home" replace /> : <LandingPage />}
        />

        {/* Public Routes */}

        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-username" element={<ForgotUsername />} />
        <Route path="/termsofservice" element={<TermsOfService />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/privacy-choices" element={<PrivacyChoices />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/myclub/login" element={<ClubLogin />} />
        <Route path="/myclub/register" element={<ClubRegister />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/unsubscribe/success" element={<UnsubscribeSuccess />} />

        {/* Semi-protected routes */}
        <Route
        path="/profile-setup"
        element={
          <ProtectedRoute>
            <ProfileSetup />
          </ProtectedRoute>
        }
        />
        <Route
        path="/checkout"
        element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        }
        />

        {/* Protected Routes */}
         <Route
        path="/member-portal/*"
        element={
                <ProtectedRoute>
              <MemberPortalRouter />
                </ProtectedRoute>
          }
         />




        <Route
        path="/myclub/dashboard"
        element={
                <ProtectedRoute>
              <ClubDashboard />
                </ProtectedRoute>
          }
         />
        <Route
        path="/club/:clubSlug"
        element={
            <ProtectedRoute>
            <CourseDetail />
            </ProtectedRoute>
        }
        />
        <Route
        path="/club/:clubId"
        element={
                <ProtectedRoute>
              <CourseDetail />
                </ProtectedRoute>
          }
         />
          <Route
          path="/myclub/dashboard/:clubId"
          element={
                <ProtectedRoute>
              <ClubDashboard />
                </ProtectedRoute>
          }
         />
            <Route
          path="/referral"
          element={
            <ProtectedRoute>
              <ReferralDashboard />
            </ProtectedRoute>
          }
         />
        <Route
          path="/about"
          element={
            <ProtectedRoute>
              <About />
            </ProtectedRoute>
          }
         />
          <Route
          path="/public"
          element={
            <ProtectedRoute>
              <PublicFinancials />
            </ProtectedRoute>
          }
         />
          <Route
          path="/myiq"
          element={
                <ProtectedRoute>
              <MyIQ />
                </ProtectedRoute>
          }
          />
          <Route
          path="/clubrequests"
          element={
                <ProtectedRoute>
              <ClubRequests />
                </ProtectedRoute>
          }
          />
        <Route
          path="/Feed"
          element={
            <ProtectedRoute>
              <Feed />
            </ProtectedRoute>
          }
        />
        <Route
          path="/post/:id"
          element={
            <ProtectedRoute>
              <PostDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messageboard"
          element={
            <ProtectedRoute>
              <MessageBoard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={

              <Contact />

          }
        />
        <Route
          path="/courses"
          element={
            <ProtectedRoute>
              <Courses />
            </ProtectedRoute>
          }
      />
       <Route
            path="/memberprofile/:username"
            element={
             <ProtectedRoute>
                <PublicProfile />
             </ProtectedRoute>
          }
        />

        {/* Main Route for Course List */}
        <Route
          path="/courselist"
          element={
            <ProtectedRoute>
              <CourseList />
            </ProtectedRoute>
          }
        />

        {/* Dynamic Route for Individual Course Details */}
        <Route
          path="/course/:id"
          element={
            <ProtectedRoute>
              <CourseDetail />
            </ProtectedRoute>
          }
        />
  <Route
    path="/forums"
    element={
      <ProtectedRoute>
        <Forums />
      </ProtectedRoute>
    }
    />
  <Route
    path="/forums/usa/:id"
    element={
      <ProtectedRoute>
        <ForumPostDetail />
      </ProtectedRoute>
    }
    />
  <Route
    path="/forums/:state/:id"
    element={
      <ProtectedRoute>
        <ForumPostDetail />
      </ProtectedRoute>
    }
  />
          <Route
    path="/myinfo"
    element={
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    }
  />
  <Route
    path="/forums/:stateCode"
    element={
      <ProtectedRoute>
        <StateForum_Unique />
      </ProtectedRoute>
    }
  />
          <Route
    path="/memberprofile/:username"
    element={
      <ProtectedRoute>
        <PublicProfile isOwnProfile={false} />
      </ProtectedRoute>
    }
  />
          <Route
    path="/memberprofile"
    element={
      <ProtectedRoute>
        <PublicProfile isOwnProfile={true} />
      </ProtectedRoute>
    }
  />
          <Route
    path="/forum"
    element={
      <ProtectedRoute>
        <Forum />
      </ProtectedRoute>
    }
    />
              <Route
    path="/contributions"
    element={
      <ProtectedRoute>
        <ContributionsPage />
      </ProtectedRoute>
    }
    />
  <Route
    path="/chat"
    element={
      <ProtectedRoute>
        <Chat />
      </ProtectedRoute>
    }
  />
            <Route
    path="/partner-discounts"
    element={
      <ProtectedRoute>
        <PartnersDiscountsPage />
      </ProtectedRoute>
    }
  />
                       <Route
    path="/feestable"
    element={
      <ProtectedRoute>
        <ModernTable />
      </ProtectedRoute>
    }

  />
        {/* Catch-All Route */}
        <Route path="*" element={<Navigate to="/" />}/>
      </Routes>
      {!isClubDashboard && <MobileNavbar />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
